import React, { useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import i18next from 'i18next';
import { withNamespaces } from 'react-i18next';
import ChangePassword from '../password/ChangePassword';

const useStyles = makeStyles((theme) => ({
    label: {
        textAlign: 'center'
    },
    divDialogBody: {
        //height: '400px',
        //textAlign: 'center'
    },
    appBar: {
        position: 'relative',
    },
    titleAppBar: {
        marginLeft: theme.spacing(2),
        flex: 1,
        fontSize: '1rem'
    },
    link: {
        marginTop: theme.spacing(2)
    },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function LoginChangePassword(props) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const { openLoginChangePassword, handleClose, userCode } = props;

    useEffect(() => {
        setOpen(openLoginChangePassword);
    }, [openLoginChangePassword]);

    const handleCloseClick = (success) => {
        handleClose(success);
    };

    return (
        /*<div className={classes.label}>*/
        <Dialog fullScreen open={open} onClose={handleCloseClick} TransitionComponent={Transition} style={{ zIndex: '10000' }}>
                <div data-id="headerLoginChangePassword" className={classes.divDialogHeader}>
                    <AppBar id="appBarTitle" className={classes.appBar}>
                        <Toolbar>
                            <IconButton edge="start" color="inherit" onClick={handleCloseClick} aria-label="close">
                                <CloseIcon />
                            </IconButton>
                            <Typography variant="h6" className={classes.titleAppBar}>
                                {i18next.t('login:login.password.titlePassword')}
                            </Typography>
                        </Toolbar>
                    </AppBar>
                </div>
                <div data-id="divRootLoginChangePassword" className={classes.divDialogBody}>
                    <ChangePassword userCode={userCode} handleClose={handleCloseClick} />
                </div>
            </Dialog>
        /*</div>*/
    );
}

export default withNamespaces(['login'], { wait: true })(LoginChangePassword);